/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LocationList = {
    type: 'array',
    contains: {
        type: 'Location',
    },
} as const;
